<template>
  <div class="mini-banners section section--big">
    <div class="container mini-banners__container">
      <nuxt-link
        v-for="(minibanner, idx) in minibanners"
        :key="idx"
        event=""
        :to="adaptUrl(minibanner.link_url)"
        class="mini-banners__link"
        @click.native="miniBannerRedirect(minibanner)"
      >
        <v-image
          :lazy="true"
          :srcset-structure="minibanner.desktop_srcset"
          :data-src="minibanner.desktop_image"
          :src="imagePlaceholder"
          class="mini-banners__img"
          :alt="minibanner.name"
          :responsive="true"
        />
        <div class="mini-banners__text-wrapper">
          <h2 class="mini-banners__text">{{ minibanner.name }}</h2>
        </div>
      </nuxt-link>
    </div>
  </div>
</template>

<script>
import VImage from '~/components/VImage.vue'
import adaptUrl from '~/commun/utils/adaptUrl'
import srcset from '~/mixins/srcset'
import pushDataLayer from '~/mixins/gtm/push-data-layer'

export default {
  name: 'Minibanners',
  components: {
    VImage,
  },
  mixins: [srcset, pushDataLayer],
  props: {
    minibanners: {
      type: Array,
      required: true,
    },
  },
  methods: {
    adaptUrl,
    miniBannerRedirect(minibanner) {
      const adaptedUrl = adaptUrl(minibanner.link_url)

      this.pushDataLayer({
        event: 'genericEvent',
        eventCategory: 'interactWithPage',
        eventAction: 'clickOnLink',
        eventLabel: 'clickOnMinibanner',
        eventValue: {
          miniBannerUrl: window.location.origin + '/' + adaptedUrl,
        },
      })

      this.$router.push(adaptedUrl)
    },
  },
}
</script>

<style lang="scss">
.shelf + .mini-banners {
  padding-top: 40px;

  @media (min-width: $v4_desktop) {
    padding-top: 68px;
  }
}

.mini-banners {
  margin-top: 15px;

  .mini-banners__link {
    display: block;
    margin-bottom: 15px;
    text-decoration: none;
    color: inherit;
  }

  .mini-banners__img {
    width: 100%;
    max-width: 100%;
    border-radius: 4px;
    background-color: #f2f2f6;
    padding-top: 296px / 345px * 100%;
    position: relative;

    img {
      border-radius: 4px;
      position: absolute;
      top: 0;
      display: block;
    }
  }

  .mini-banners__text {
    display: block;
    font-size: 21px;
    text-align: center;
    margin-top: 5px;
    font-weight: 700;
    padding-bottom: 5px;
  }

  @media (min-width: $v4_desktop) {
    margin-bottom: 30px;

    & + .mini-banners {
      margin-bottom: 60px;
    }

    .mini-banners__container {
      padding-left: 0;
      padding-right: 0;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-column-gap: 18px;

      &:before {
        display: none;
      }

      .mini-banners__link {
        width: 100%;
        margin: 0;
      }

      .mini-banners__img {
        padding-top: 324px / 378px * 100%;
      }
    }
  }
}
</style>
